import React from 'react';

import ModalTaskLink from "./link-entity/task-link/task-link";
import ModalEditorMentionsNote from "./editor-mentions/editor-mentions-notes";

export default class EditorMentionsModalsManager {

    constructor() {}

    taskMention(companyId, projectId, callback) {
        gd.modal.showV4({
            className: 'modal-editor-mentions',
            component: ModalTaskLink,
            params: {
                companyId,
                projectId,
                onSubmit: (result)=>{
                    if (callback) callback(result);
                    gd.modal.hide();
                },
            }
        });
    }

    noteMention(companyId, projectId, callback) {
        gd.modal.showV4({
            className: 'modal-editor-mentions',
            component: ModalEditorMentionsNote,
            params: {
                companyId,
                projectId,
                onSubmit: (result)=>{
                    if (callback) callback(result);
                    gd.modal.hide();
                },
            }
        });
    }
}